import { useGetData, useSetData } from '@/data/Data.hook';

const key = 'userStatus';

export type TUseSetUserStatusData = {
  isVerified: boolean;
  isGuest: boolean;
  isAnonymous: boolean;
  status: 'VERIFIED' | 'GUEST' | 'ANONYMOUS';
};

export const useSetUserStatus = () => {
  const setter = useSetData(key);

  return (status: TUseSetUserStatusData['status']) =>
    setter({
      status,
      isVerified: status === 'VERIFIED',
      isGuest: status === 'GUEST',
      isAnonymous: status === 'ANONYMOUS',
    });
};

export const useGetUserStatus = (): TUseSetUserStatusData =>
  useGetData(key) ?? {};
